function shareMyCart() {
  // Fetch the current cart data from Shopify's native API
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count === 0) {
        alert('Your cart is empty! Add some items before sharing.');
        return;
      }

      // Map over the items to create the "VariantID:Quantity" format
      const items = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
      
      // Construct the absolute permalink URL
      const shareUrl = `${window.location.origin}/cart/${items}?storefront=true`;

      // Copy the URL to the user's clipboard
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          // Provide instant visual feedback on the button
          const btn = document.getElementById('share-cart-btn');
          const originalText = btn.innerHTML;
          btn.innerHTML = '✓ Link Copied!';
          setTimeout(() => { btn.innerHTML = originalText; }, 2500);
        })
        .catch(err => {
          console.error('Could not copy text: ', err);
          alert('Here is your cart link: ' + shareUrl);
        });
    });
}